// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".outer-bar[data-v-a31aada6]{background:#f1f3f2;width:100%}.inner-bar[data-v-a31aada6],.outer-bar[data-v-a31aada6]{border-radius:999px;height:8px}.inner-bar[data-v-a31aada6]{background:#6b4392}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
